import React from 'react';
import { Play } from 'lucide-react';
export function Sidebar() {
  return <aside className="space-y-6 sticky top-24 font-sans" data-id="element-29">
      {/* CTA Card */}
      <div className="bg-navy text-white p-8 text-center shadow-lg" data-id="element-30">
        <div className="text-xs tracking-[0.15em] uppercase text-gray-400 mb-3 font-medium" data-id="element-31">
          Limited Offer
        </div>
        <h3 className="font-display text-2xl sm:text-3xl font-bold mb-3 leading-tight" data-id="element-32">
          Energy Revolution System
        </h3>
        <p className="text-sm text-gray-300 mb-6 px-4" data-id="element-33">
          $39 guide + 60-day money-back guarantee
        </p>
        <a href="https://theenergyrevolution.net/cb_redirect.php?&shield=f00f4blfr2m17o2-vnso2k2x04" target="_blank" rel="noopener sponsored" className="w-full bg-orange hover:bg-orange-hover text-white font-bold py-3.5 px-4 rounded flex items-center justify-center transition-colors group" data-id="element-34">
          <Play className="w-4 h-4 mr-2 fill-current group-hover:scale-110 transition-transform" data-id="element-35" />
          Watch Free Video
        </a>
        <p className="text-xs text-gray-400 mt-4" data-id="element-36">No risk · Instant access</p>
      </div>

      {/* Score Card */}
      <div className="bg-white border border-gray-200 p-8 text-center shadow-sm" data-id="element-37">
        <div className="text-xs tracking-widest uppercase text-gray-500 mb-6 font-medium" data-id="element-38">
          EIJ Score
        </div>
        <div className="w-20 h-20 bg-navy rounded-full flex flex-col items-center justify-center mx-auto mb-5 text-white shadow-inner" data-id="element-39">
          <span className="text-2xl font-bold leading-none mb-0.5" data-id="element-40">8.2</span>
          <span className="text-[10px] opacity-70 tracking-widest border-t border-white/20 pt-0.5 w-8 text-center" data-id="element-41">
            /10
          </span>
        </div>
        <div className="font-bold text-navy text-lg mb-1" data-id="element-42">Recommended</div>
        <div className="text-sm text-gray-500 italic font-serif" data-id="element-43">
          With realistic expectations
        </div>
      </div>

      {/* Test Results Card */}
      <div className="bg-white border border-gray-200 p-6 shadow-sm" data-id="element-44">
        <div className="text-xs tracking-widest uppercase text-gray-500 mb-5 font-medium" data-id="element-45">
          Test Results At A Glance
        </div>
        <div className="space-y-4 text-sm" data-id="element-46">
          <div className="flex justify-between border-b border-gray-100 pb-3" data-id="element-47">
            <span className="text-gray-600" data-id="element-48">Monthly savings</span>
            <span className="font-bold text-navy" data-id="element-49">$22–$38</span>
          </div>
          <div className="flex justify-between border-b border-gray-100 pb-3" data-id="element-50">
            <span className="text-gray-600" data-id="element-51">Build time</span>
            <span className="font-bold text-navy" data-id="element-52">3–10 hrs</span>
          </div>
          <div className="flex justify-between" data-id="element-53">
            <span className="text-gray-600" data-id="element-54">Total cost</span>
            <span className="font-bold text-navy" data-id="element-55">$100–$250</span>
          </div>
        </div>
      </div>
    </aside>;
}